<div class="language-selector" role="group" [attr.aria-label]="ariaLabel()">
  @for (language of languages; track language) {
    <button
      type="button"
      class="language-selector__option"
      [class.language-selector__option--active]="language === activeLanguage()"
      [attr.aria-pressed]="language === activeLanguage()"
      (click)="select(language)"
    >
      {{ language.toUpperCase() }}
    </button>
  }
</div>
